<template>
    <v-list-item
        class='msp-chat'
        @click="select()"
    >
        <msp-avatar v-if="commento.utente" :utente="commento.utente"></msp-avatar>

        <v-list-item-content>

            <v-list-item-title class='titolo'>
                <span class='nome' v-if="commento.utente">
                    {{commento.utente.nome}} {{commento.utente.cognome}}
                </span>
            </v-list-item-title>
            <span class='sport'><i :class="iconaSport"></i></span>
            <template v-if="commento">
                <div class="ultimo" v-text="commento.excerpt"> </div>
                <div class="inviato" >{{shortDate(commento.messaggio.utc_data_inviato)}}</div>
            </template>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
import env from '@mixins/environment.js'
import calendario from '@shared/mixins/calendario.js'
import MspAvatar from "./MspAvatar.vue"
    const component = {
        components: {
            MspAvatar,
        },
        props: [
            'commento'
        ],
        computed: {
            iconaSport: function () {
                let sportId = this.commento.messaggio.sport_id;
                return "msp-icon-sport-"+sportId;
            },
        },
        data() {
            return {
            }
        },
        mounted: function () {
            this.init();
        },
        mixins: [
            env
        ],
        methods: {
            shortDate: function (value) {
                if (!value) return ''
                let shortDate;
                let date = calendario.utcStringToLocalDate(value);
                let now = new Date();
                if (now.toDateString() === date.toDateString()) {
                    shortDate = date.toLocaleTimeString();
                } else {
                    shortDate = date.toLocaleDateString();
                }

                return shortDate;
            },
            init: function () {},
            initials: function (utente) {
                let output = "";
                if (utente.nome) {
                    output += utente.nome.substr(0,1);
                }
                if (utente.cognome) {
                    output += utente.cognome.substr(0,1);
                }
                return output;
            },
            select: function () {
                this.$emit('select', this.commento);
            }
        }
    }
    export default component;
</script>

<style lang="scss">
.msp-chat {
    --col-avatar: var(--col-grigio-chiaro);
    --size-avatar: 100%;
    border-bottom: 3px solid var(--col-grigio-chiaro);
    .v-list-item__content {
        display: grid;
        grid-template-columns: 1fr auto;
        grid-template-rows: auto auto auto;
        grid-template-areas: "titolo sport" "ultimo sport" "inviato inviato";
        align-items: start;
    }
    .sport {
        font-size: 40px;
        grid-area: sport;
        display: grid;
    }
    .nome {
        font-weight: bold;
    }
    .ultimo {
        grid-area: ultimo;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .titolo {
        grid-area: titolo;
    }
    .inviato {
        grid-area: inviato;
        text-align: right;
        font-style: italic;
        font-size: 0.8em;
    }
    }
</style>
